import {
  Competitions,
  CreateCompetition,
  EditCompetition,
} from "./Competitions";

import Votes from "./Votes";
// import Participants from "./Participants/Participants";
import { Participants, UpdateParticipants, CreateVotes } from "./Participants";

export {
  Competitions,
  CreateCompetition,
  EditCompetition,
  Votes,
  Participants,
  UpdateParticipants,
  CreateVotes,
};
